import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        apiBaseUrl: process.env.VUE_APP_API_BASE_URL || "https://api.fabricfour.com/api",
        user: null,
        jwt: null,
        isAuthenticated: false,
        isAdmin: false,
        isAuthor: false,
        showHomeHeader: true,
        courses: [],
        cart: [],
        requestOverlayText: null,
        requestErrorCode: null,
        requestBusy: false,
        breadCrumbs: null,
    },
    getters: {
        getUser(state) {
            return state.user;
        },
        userAuthenticated(state) {
            return state.isAuthenticated;
        }
    },
    mutations: {
        breadCrumbs(state, crumbs) {
            state.breadCrumbs = crumbs;
        },
        setRequestBusy(state, isBusy) {
            state.requestBusy = isBusy;
        },
        setOverlayText(state, text) {
            state.requestOverlayText = text;
        },
        setErrorCode(state, code) {
            state.requestErrorCode = code;
        },
        setUserState(state, userState) {
            if (userState == null) {
                state.isAuthenticated = false;
                state.user = null;
                state.jwt = null;
                localStorage.removeItem("userState");
            }
            else {
                state.isAuthenticated = true;
                state.user = userState.user;
                state.jwt = userState.jwt;
                localStorage.setItem("userState", JSON.stringify(userState));

                if (state.user.roles) {
                    state.isAdmin = state.user.roles.indexOf("admin") > -1;
                    state.isAuthor = state.user.roles.indexOf("author") > -1;
                }

                router.replace("/");
            }
        },
        loadUserState(state) {

            var userState = JSON.parse(localStorage.getItem("userState"));
            if (userState) {
                state.isAuthenticated = true;
                state.user = userState.user;
                state.jwt = userState.jwt;

                if (state.user.roles) {
                    state.isAdmin = state.user.roles.indexOf("admin") > -1;
                    state.isAuthor = state.user.roles.indexOf("author") > -1;
                }
            }
        },
        setUser(state, user) {
            //used to update just the user when changes are made from the dashboard
            var localStoreUserState = JSON.parse(localStorage.getItem("userState"));
            state.user = user;
            localStoreUserState.user = user;
            localStorage.setItem("userState", JSON.stringify(localStoreUserState));
        },
    },
    actions: {
    },
    modules: {
    }
})